import { createTheme } from '@mui/material/styles';
import * as tokens from '@deere/fuel-tokens/dist/web/jd-green/tokens';
export const baseTheme = createTheme({
    breakpoints: {
        values: {
            base: 0,
            xs: 360,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536
        }
    },
    palette: {
        common: {
            black: tokens.FuelColorBlack,
            white: tokens.FuelColorWhite
        },
        primary: {
            main: tokens.FuelColorBrandPrimary,
            light: tokens.FuelColorGreen400,
            dark: tokens.FuelColorGreen700,
            contrastText: tokens.FuelColorWhite
        },
        secondary: {
            main: tokens.FuelColorBrandSecondary,
            light: tokens.FuelColorYellow100,
            dark: tokens.FuelColorYellow700,
            contrastText: tokens.FuelColorTextPrimary
        },
        error: {
            main: tokens.FuelColorAlertErrorIcon, // danger dark - same as what's in jd-green & jd-black
            light: tokens.FuelColorAlertErrorBackground, // danger light
            dark: tokens.FuelColorAlertErrorIcon, // danger dark
            contrastText: tokens.FuelColorWhite
        },
        warning: {
            main: tokens.FuelColorAlertWarningBorder, // warning base
            light: tokens.FuelColorAlertWarningBackground, // warning light
            dark: tokens.FuelColorAlertWarningIcon, // warning dark
            contrastText: tokens.FuelColorWhite
        },
        info: {
            main: tokens.FuelColorAlertInfoBorder, // informational base
            light: tokens.FuelColorAlertInfoBackground, // information light
            dark: tokens.FuelColorAlertInfoIcon, // informational dark
            contrastText: tokens.FuelColorTextPrimary
        },
        success: {
            main: tokens.FuelColorAlertSuccessBorder, // success base
            light: tokens.FuelColorAlertSuccessBackground, // success light
            dark: tokens.FuelColorAlertSuccessIcon, // success dark
            contrastText: tokens.FuelColorWhite
        },
        grey: {
            '50': tokens.FuelColorGray50,
            '100': tokens.FuelColorGray100,
            '200': tokens.FuelColorGray200,
            '300': tokens.FuelColorGray300,
            '400': tokens.FuelColorGray400,
            '500': tokens.FuelColorGray500,
            '600': tokens.FuelColorGray600,
            '700': tokens.FuelColorGray700,
            '800': tokens.FuelColorGray800,
            '900': tokens.FuelColorGray900,
            A100: tokens.FuelColorGray100,
            A200: tokens.FuelColorGray200,
            A400: tokens.FuelColorGray400,
            A700: tokens.FuelColorGray700
        },
        text: {
            primary: tokens.FuelColorTextPrimary,
            secondary: tokens.FuelColorTextSecondary,
            tertiary: tokens.FuelColorTextTertiary,
            disabled: tokens.FuelColorTextDisabled,
            body: tokens.FuelColorTextBody,
            heading: tokens.FuelColorTextHeading,
            icon: tokens.FuelColorTextIcon
        },
        divider: tokens.FuelColorBorderLight,
        background: {
            default: tokens.FuelColorBackgroundGray
        }
    },
    spacing: (factor) => `${0.25 * factor}rem`,
    shadows: [
        'none',
        tokens.FuelShadowMd,
        tokens.FuelShadowMd,
        tokens.FuelShadowMd,
        tokens.FuelShadowMd,
        tokens.FuelShadowLg,
        tokens.FuelShadowLg,
        tokens.FuelShadowLg,
        tokens.FuelShadowXl,
        tokens.FuelShadowXl,
        tokens.FuelShadowXl,
        tokens.FuelShadowXl,
        tokens.FuelShadowXl,
        tokens.FuelShadowXl,
        tokens.FuelShadowXl,
        tokens.FuelShadowXl,
        tokens.FuelShadow2xl,
        tokens.FuelShadow2xl,
        tokens.FuelShadow2xl,
        tokens.FuelShadow2xl,
        tokens.FuelShadow2xl,
        tokens.FuelShadow2xl,
        tokens.FuelShadow2xl,
        tokens.FuelShadow2xl,
        tokens.FuelShadow2xl
    ],
    typography: {
        fontFamily: tokens.FuelFontFamilyBase,
        fontWeightLight: tokens.FuelFontWeightRegular,
        fontWeightRegular: tokens.FuelFontWeightRegular,
        fontWeightMedium: tokens.FuelFontWeightSemibold,
        fontWeightBold: tokens.FuelFontWeightBold,
        h1: {
            fontWeight: tokens.FuelFontWeightSemibold,
            fontSize: tokens.FuelFontSizeHeading1,
            lineHeight: tokens.FuelLineHeight2xl
        },
        h2: {
            fontWeight: tokens.FuelFontWeightSemibold,
            fontSize: tokens.FuelFontSizeHeading2,
            lineHeight: tokens.FuelLineHeightXl
        },
        h3: {
            fontWeight: tokens.FuelFontWeightSemibold,
            fontSize: tokens.FuelFontSizeHeading3,
            lineHeight: tokens.FuelLineHeightXl
        },
        h4: {
            fontWeight: tokens.FuelFontWeightSemibold,
            fontSize: tokens.FuelFontSizeHeading4,
            lineHeight: tokens.FuelLineHeightMd
        },
        h5: {
            fontWeight: tokens.FuelFontWeightSemibold,
            fontSize: tokens.FuelFontSizeHeading5,
            lineHeight: tokens.FuelLineHeightSm
        },
        h6: {
            fontWeight: tokens.FuelFontWeightSemibold,
            fontSize: tokens.FuelFontSizeHeading6,
            lineHeight: tokens.FuelLineHeightSm
        },
        subtitle1: {
            color: tokens.FuelColorTextTertiary,
            fontWeight: tokens.FuelFontWeightSemibold,
            fontSize: tokens.FuelFontSizeSm,
            lineHeight: tokens.FuelLineHeightSm
        },
        subtitle2: {
            fontWeight: tokens.FuelFontWeightSemibold,
            color: tokens.FuelColorTextTertiary,
            fontSize: tokens.FuelFontSizeXs,
            lineHeight: tokens.FuelLineHeightXs
        },
        body1: {
            fontSize: tokens.FuelFontSizeMd
        },
        button: {
            textTransform: 'none',
            fontSize: tokens.FuelFontSizeSm,
            lineHeight: tokens.FuelLineHeightMd,
            fontWeight: tokens.FuelFontWeightSemibold
        },
        caption: {
            fontSize: tokens.FuelFontSizeXs,
            lineHeight: tokens.FuelLineHeightXs,
            fontWeight: tokens.FuelFontWeightRegular
        },
        overline: {
            fontSize: tokens.FuelFontSizeXs,
            lineHeight: tokens.FuelLineHeightXs,
            fontWeight: tokens.FuelFontWeightRegular
        },
        label: {
            fontSize: tokens.FuelFontSizeSm,
            lineHeight: tokens.FuelLineHeightSm,
            fontWeight: tokens.FuelFontWeightSemibold
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0,0,0,0)',
            height: '1px',
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            whiteSpace: 'nowrap',
            width: '1px'
        }
    }
});
